import appInstall from '@/utils/appUtils/appInstall'
import { compareVersion, getAppVersion, isDuApp } from '@/utils/appUtils/getDevice'
import Jockeys from '@/utils/jockey'
import { Toast } from 'antd-mobile'
import React from 'react'
import styles from '../index.module.less'
import { cdnSrc } from '@/utils/cdn'

export class GoodsItem extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props)
  }

  handleOnload() {
    console.log('handleOnload')
  }

  productClick({ url, spuId, redirectType }: CardGoods) {
    if (url) {
      this.goToProductVenue(url, redirectType)
    } else {
      this.goToDetail(spuId)
    }
  }

  goToProductVenue(url: string, redirectType: number) {
    if (isDuApp()) {
      if (redirectType === 1) {
        Jockeys.openNativePage(url)
      } else {
        Jockeys.openNativePage('/web/browser', { url })
      }
    } else {
      window.location.href = url
    }
  }

  goToDetail(spuId: string) {
    if (isDuApp() && compareVersion(getAppVersion(), '2.1.5') !== -1) {
      Jockeys.openNativePage('/sell/productDetail', {
        spuId,
      })
      return
    }

    if (isDuApp()) {
      const msg = '貨號已複製，暫僅可在首頁粘貼並搜索。'
      Toast.info(msg)
      return
    }

    appInstall('/sell/productDetail', { spuId })
  }

  render() {
    const { product } = this.props
    const { subTitle, logoUrl, priceShow, desc } = product
    const cdnSrcString = cdnSrc(logoUrl, [{ mode: 'resize', width: 95 * 2 }])

    return (
      <div className={styles['goods-item-wapper']} onClick={() => this.productClick(product)}>
        <div className={styles['goods-item']}>
          {/* 二倍图 */}
          <img className="swiper-lazy" src="" data-src={cdnSrcString} alt="" />
          {/* title */}
          <div className={styles['goods-title']}>{subTitle}</div>
          {/* 描述 */}
          {!desc ? (
            <div className={styles['goods-price']}>{priceShow}</div>
          ) : (
            <div className={styles['goods-desc']}>{desc}</div>
          )}
        </div>
      </div>
    )
  }
}

export interface CardGoods {
  id: string
  // 1 代表直接直接跳转，用这个的原因是因为有可能url存在，但是type不对
  redirectType: number
  subTitle: string
  desc: string
  spuId: string
  logoUrl: string
  title: string
  price: number
  soldNum: number
  url?: string
  priceShow?: string
}

interface IProps {
  product: CardGoods
}
